import HomeClient from '@/components/HomeClient';

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "CatanduvasPR.com.br",
    "url": "https://catanduvaspr.com.br",
    "description": "O guia completo da cidade de Catanduvas PR. Portal de informações locais e guia de serviços, incluindo farmácias de plantão e telefones de emergência.",
    "publisher": {
      "@type": "Organization",
      "name": "CatanduvasPR.com.br",
      "location": {
        "@type": "Place",
        "name": "Catanduvas, PR"
      }
    }
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <HomeClient />
    </>
  );
}

